import { apiErrorMessage } from '@bayesprep/shared-ui/errors';

export interface LoginFormData { email: string; password: string; }
export type LoginField = keyof LoginFormData;
export const loginFields: LoginField[] = ['email', 'password'];

export function loginFieldError(field: LoginField, value: string, emailValid = true): string | undefined {
  if (field === 'password') return value.length ? undefined : 'Enter your password.';
  if (!value.trim()) return 'Enter your email address.';
  if (field === 'email' && !emailValid) return 'Enter a valid email address, such as student@example.com.';
  return undefined;
}

export function normalizeLogin(data: LoginFormData): LoginFormData {
  return { email: data.email.trim(), password: data.password };
}

export function loginErrorMessage(error: unknown): string {
  return apiErrorMessage(error, 'Unable to sign in. Check your details or contact your institution.', { login: true });
}
